import { gql } from '@apollo/client';

export const DocumentEventFragment = gql`
  fragment DocumentEvent on DocumentEvent {
    id
    documentType
    eventType
    fiscalYearId
    periodName
    period {
      startMonthYear {
        month
        year
      }
      endMonthYear {
        month
        year
      }
    }
  }
`;
